import React, { useState } from "react";

import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";

import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, message, Row, Upload } from "antd";
import { BsInfoCircleFill } from "react-icons/bs";

import "./LogoSettings.css";

const LogoSettingsRightBar = [];

function LogoSettings() {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = () => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("files[]", file);
    });
    setUploading(true);
    // You can use any AJAX library you like
    fetch("https://www.mocky.io/v2/5cc8019d300000980a055e76", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then(() => {
        setFileList([]);
        message.success("upload successfully.");
      })
      .catch(() => {
        message.error("upload failed.");
      })
      .finally(() => {
        setUploading(false);
      });
  };

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);

      return false;
    },
    fileList,
  };
  return (
    <>
      <Row>
        <Col span={24}>
          <div className="logo-settings">
            <PageHeading heading="Upload Logo" />
            <div className="info-container">
              <BsInfoCircleFill />
              <span>
                jpg, gif, and png images, 3 MB max size. For best results, use
                an image with a transparent or white background.
              </span>
            </div>
            <Upload {...uploadProps}>
              <Button icon={<UploadOutlined />}>Select File</Button>
            </Upload>
            <Button
              type="primary"
              onClick={handleUpload}
              disabled={fileList.length === 0}
              loading={uploading}
              style={{ marginTop: 16 }}
            >
              {uploading ? "Uploading" : "Start Upload"}
            </Button>
          </div>
        </Col>
      </Row>
      <div className="RightSidebar">
        <RightBar RightBarData={LogoSettingsRightBar} />
      </div>
    </>
  );
}

export default LogoSettings;
